import { LoyaltyProgramCategory, MembershipType } from '@rd/types';
import { z } from 'zod';

export const cashBackToAccountMembershipModelSchema = z.object({
  userId: z.string(),
  loyaltyProgramId: z.string(),
  loyaltyProgramName: z.string(),
  number: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  preferred: z.boolean(),
  category: z.literal(LoyaltyProgramCategory.CashbackToAccount),
  enrollmentId: z.null(),
  enrollment: z.null(),
  details: z.object({
    bsbNumber: z.string(),
  }),
});

export const cashBackToCardMembershipModelSchema = z.object({
  userId: z.string(),
  loyaltyProgramId: z.string(),
  loyaltyProgramName: z.string(),
  number: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  preferred: z.boolean(),
  category: z.literal(LoyaltyProgramCategory.CashbackToCard),
  enrollmentId: z.string(),
  enrollment: z.object({
    id: z.string(),
    groupName: z.string(),
    status: z.literal('active'),
  }),
  details: z.object({
    groupName: z.string(),
  }),
});

export const cashBackModelSchema = z.object({
  id: z.string(),
  type: z.literal(MembershipType.CashBack),
  attributes: z.discriminatedUnion('category', [
    cashBackToAccountMembershipModelSchema,
    cashBackToCardMembershipModelSchema,
  ]),
});

export const pointsTransferMembershipModelSchema = z.object({
  id: z.string(),
  type: z.literal(MembershipType.PointsTransfer),
  attributes: z.object({
    category: z.union([
      z.literal(LoyaltyProgramCategory.Airline),
      z.literal(LoyaltyProgramCategory.Hotel),
      z.literal(LoyaltyProgramCategory.Others),
    ]),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    loyaltyProgramId: z.string(),
    loyaltyProgramName: z.string(),
    number: z.string(),
    preferred: z.boolean(),
    userId: z.string(),
    dateOfBirth: z.string().optional(),
  }),
});

export const membershipModelSchema = z.discriminatedUnion('type', [
  cashBackModelSchema,
  pointsTransferMembershipModelSchema,
]);

export const membershipResponseSchema = z.object({
  data: z.array(membershipModelSchema),
});

export const redeemCashMembershipResponseSchema = z.object({
  data: z.array(cashBackModelSchema),
});

export const createMembershipResponseSchema = z.object({
  data: membershipModelSchema,
});

export const updateMembershipResponseSchema = z.object({
  data: membershipModelSchema,
});

export const linkMembershipResponseSchema = z.object({
  url: z.string(),
});

export const unlinkMembershipResponseSchema = z.object({
  url: z.string(),
});
